import React from 'react';
import project1 from '../../assets2/project1.JPG';
import project2 from '../../assets2/project2.JPG';
import project3 from '../../assets2/project3.JPG';
import project4 from '../../assets2/project4.JPG';
import './Work.css';

const Work = () => {
  const projects = [
    {
      id: 1,
      image: project1,
      title: "Smart Greenhouse",
      description: "Automated climate control system for commercial greenhouses"
    },
    {
      id: 2,
      image: project2,
      title: "Urban Farm",
      description: "IoT monitoring solution for vertical farming operations"
    },
    {
      id: 3,
      image: project3,
      title: "Research Facility",
      description: "Precision monitoring for agricultural research and development"
    },
    {
      id: 4,
      image: project4,
      title: "Home Garden",
      description: "Personal plant monitoring system for home gardeners"
    }
  ];

  return (
    <section className="work-section">
      <div className="work-container">
        <div className="work-header">
          <h2>Our Projects</h2>
          <p>Here are various use cases for our platform and who would benefit from this seamless integration.</p>
        </div>
        
        <div className="work-grid">
          {projects.map((project) => (
            <div key={project.id} className="work-card">
              <div className="work-image">
                <img src={project.image} alt={project.title} />
                <div className="work-overlay">
                  <div className="work-content">
                    <h3>{project.title}</h3>
                    <p>{project.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Work;
